module.exports = __webpack_public_path__ + "static/FredokaOne-Regular-4a2f2ea45a0bb1abe81b47d0afde4aae.ttf";